document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.querySelector('.blog-tagbar-outer');
  const sectionHeader = document.querySelector('.section-header');
    // Check if the sticky bar exists
    if (stickyBar) {
      const stickyBarOffset = stickyBar.offsetTop; // Get the offset position of the sticky bar
      window.addEventListener('scroll', function() {
        if (window.scrollY  >= stickyBarOffset) {
          stickyBar.classList.add('tag-sticky');  // Add sticky class when bar reaches the top
        } else {
          stickyBar.classList.remove('tag-sticky');  // Remove sticky class when bar is above the section
        }
      });
    }
});
  